import { render, staticRenderFns } from "./SendPermitMemos.vue?vue&type=template&id=500e7bb3"
import script from "./SendPermitMemos.vue?vue&type=script&lang=js"
export * from "./SendPermitMemos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports